import { Component, Inject } from '@angular/core';
import { NgProgress } from '@ngx-progressbar/core';
import { ToastrService } from 'ngx-toastr';
import { APIOperableComponent } from '../../../../shared/components/api-operable/api-operable.component';
import { AddeableComponent } from '../../../../shared/components/interfaces/addeable.component';
import { UIActiveDialogService } from '../../../../shared/services/ui-dialog.service';
import { AuthService } from '../../../security/service/auth.service';
import { PartTypeUIMessages } from '../../model/part-type-ui.messages';
import { PartsTypeModel } from '../../model/part-type.model';
import { PartTypeService } from '../../service/part-type.service';

@Component({
  selector: 'part-type-add-dialog',
  templateUrl:
    'console/app-js/modules/partType/components/part-type-add-dialog/part-type-add-dialog.component.html'
})
export class PartTypeAddDialogComponent extends APIOperableComponent
  implements AddeableComponent {
  protected partTypeModel: PartsTypeModel = new PartsTypeModel();
  private originalModel: PartsTypeModel;
  private partTypeId: number;
  private allPartTypes: Array<PartsTypeModel> = [];
  private currentPartTypeNames: Array<string> = [];

  constructor(
    @Inject('partsTypeModel') partType: PartsTypeModel,
    progressService: NgProgress,
    toastr: ToastrService,
    authService: AuthService,
    private partTypeService: PartTypeService,
    private activeDialogService: UIActiveDialogService
  ) {
    super(progressService, toastr, authService);
    this.partTypeId = partType ? partType.id : null;
    this.loadAllPartTypes();
  }

  /**
   * Loads all parts and extract it's names to validate.
   */
  private loadAllPartTypes(): void {
    this.loadingIndicator = true;
    this.partTypeService.getPartTypes().subscribe(
      result => {
        this.allPartTypes = result ? result : [];
        this.currentPartTypeNames = this.allPartTypes.map(item => item.name);
        this.loadingIndicator = false;
      },
      err => this.onAPIError(PartTypeUIMessages.LOAD_PART_TYPE_LIST_ERROR)
    );
  }

  /**
   * Create new PART type onSave.
   */
  onSave(): void {
    this.startProgress();
    // Create
    this.partTypeModel.isActive = true;
    this.partTypeService.createPartType(this.partTypeModel).subscribe(
      response => {
        if (response.responseCode === 200) {
          this.onAPISuccess(PartTypeUIMessages.ADD_PART_TYPE_SUCCESS);
          this.activeDialogService.close(true);
          this.finishProgress();
        } else {
          this.onAPIError(PartTypeUIMessages.ADD_PART_TYPE_ERROR);
          this.finishProgress();
        }
      },
      error => {
        this.onAPIError(PartTypeUIMessages.ADD_PART_TYPE_ERROR);
        this.finishProgress();
      }
    );
  }

  /**
   * Check the form is dirty.
   */
  isDirty(): boolean {
    if (this.originalModel) {
      return (
        JSON.stringify(this.originalModel) !==
        JSON.stringify(this.partTypeModel)
      );
    } else {
      // Create always dirty
      return true;
    }
  }

  /**
   * Cancel adding new part type.
   */
  onCancel(): void {
    this.activeDialogService.dismiss();
  }

  /**
   * Determines if the current name input by user is already in use.
   * @returns {boolean}
   */
  protected isNameInUse(): boolean {
    const match =
      this.partTypeModel.name &&
      this.currentPartTypeNames.find(
        item =>
          item.toLocaleLowerCase().trim() ===
          this.partTypeModel.name.trim().toLocaleLowerCase()
      );
    if (match && this.originalModel) {
      return (
        match.toLocaleLowerCase() !==
        this.originalModel.name.toLocaleLowerCase()
      );
    }
    return match && match.length > 0;
  }
}
